import JwtService from "./jwtService";

export default function useJwt(axiosIns) {
  const jwt = new JwtService(axiosIns);

  return {
    jwt,
  };
}
